// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-guide {
  margin-bottom: 32px;
}
.user-guide .guide-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 16px 0;
}
.user-guide .guide-header h3 {
  font-size: 28px;
  font-weight: 700;
  font-family: 'Outfit', sans-serif;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}
.user-guide .guide-cards .guide-card {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: var(--shadow-sm);
}
.user-guide .guide-cards .guide-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--step-color, #4f46e5) 0%, rgba(255, 255, 255, 0) 100%);
  opacity: 0.6;
  transition: opacity 0.3s ease;
}
.user-guide .guide-cards .guide-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-float);
  background: rgba(255, 255, 255, 0.9);
}
.user-guide .guide-cards .guide-card:hover::before {
  opacity: 1;
  height: 6px;
}
.user-guide .guide-cards .guide-card.guide-card-1 {
  --step-color: #4f46e5;
}
.user-guide .guide-cards .guide-card.guide-card-2 {
  --step-color: #ec4899;
}
.user-guide .guide-cards .guide-card.guide-card-3 {
  --step-color: #8b5cf6;
}
.user-guide .guide-cards .guide-card.guide-card-4 {
  --step-color: #06b6d4;
}
.user-guide .guide-cards .guide-card .card-header {
  text-align: center;
  padding-top: 8px;
}
.user-guide .guide-cards .guide-card .card-header .step-number {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0.6;
  margin-bottom: 8px;
}
.user-guide .guide-cards .guide-card .card-header .step-icon {
  margin: 0 auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.user-guide .guide-cards .guide-card:hover .step-icon {
  transform: scale(1.1) rotate(5deg);
}
.user-guide .guide-cards .guide-card .card-content .sample-image-container {
  text-align: center;
}
.user-guide .guide-cards .guide-card .card-content .sample-image-container .ant-image {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.user-guide .guide-cards .guide-card .card-content .ant-list-item {
  padding: 8px 0;
  border: none;
  font-size: 14px;
  color: #64748b;
}
.user-guide .guide-cards .guide-card .card-content .ant-list-item:last-child {
  padding-bottom: 0;
}
.user-guide .guide-cards .guide-card .card-content .ant-alert {
  border-radius: 10px;
  border: none;
  background: rgba(240, 253, 244, 0.8);
}
.user-guide .guide-cards .guide-card .card-content .ant-alert .ant-alert-message {
  font-weight: 600;
  color: #15803d;
}
.user-guide .guide-cards .guide-card .card-content .ant-alert .ant-alert-description {
  color: #166534;
}
@media (max-width: 768px) {
  .user-guide .guide-header h3 {
    font-size: 24px;
  }
  .user-guide .guide-cards .guide-card {
    margin-bottom: 24px;
  }
  .user-guide .guide-cards .guide-card .card-header .step-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/UserGuide.less"],"names":[],"mappings":"AACA;EACE,mBAAA;AAAF;AADA;EAII,kBAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AANA;EASM,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mCAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;AAAN;AAhBA;EAsBM,iDAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;AAHN;AAKM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,8FAAA;EACA,YAAA;EACA,6BAAA;AAHR;AAMM;EACE,2BAAA;EACA,+BAAA;EACA,oCAAA;AAJR;AAMQ;EACE,UAAA;EACA,WAAA;AAJV;AAQM;EACE,qBAAA;AANR;AASM;EACE,qBAAA;AAPR;AAUM;EACE,qBAAA;AARR;AAWM;EACE,qBAAA;AATR;AA1DA;EAuEQ,kBAAA;EACA,gBAAA;AAVR;AA9DA;EA2EU,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAVV;AAtEA;EAoFU,cAAA;EACA,yCAAA;EACA,+BAAA;AAXV;AAeM;EACE,kCAAA;AAbR;AA9EA;EAgGU,kBAAA;AAfV;AAjFA;EAmGY,mBAAA;EACA,gBAAA;EACA,yCAAA;AAfZ;AAtFA;EA0GU,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAjBV;AAmBU;EACE,iBAAA;AAjBZ;AA/FA;EAqHU,mBAAA;EACA,YAAA;EACA,oCAAA;AAnBV;AApGA;EA0HY,gBAAA;EACA,cAAA;AAnBZ;AAxGA;EA+HY,cAAA;AApBZ;AA6BA;EACE;IAGM,eAAA;EA7BN;EA0BA;IASM,mBAAA;EAhCN;EAuBA;IAaU,WAAA;IACA,YAAA;IACA,eAAA;EAjCV;AACF","sourcesContent":["// 用户指南样式\n.user-guide {\n  margin-bottom: 32px;\n  \n  .guide-header {\n    text-align: center;\n    margin-bottom: 32px;\n    padding: 16px 0;\n    \n    h3 {\n      font-size: 28px;\n      font-weight: 700;\n      font-family: 'Outfit', sans-serif;\n      background: var(--gradient-primary);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      margin-bottom: 8px;\n    }\n  }\n  \n  .guide-cards {\n    .guide-card {\n      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n      border-radius: 16px;\n      position: relative;\n      overflow: hidden;\n      background: rgba(255, 255, 255, 0.7);\n      backdrop-filter: blur(12px);\n      border: 1px solid rgba(255, 255, 255, 0.5);\n      box-shadow: var(--shadow-sm);\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 4px;\n        background: linear-gradient(90deg, var(--step-color, #4f46e5) 0%, rgba(255, 255, 255, 0) 100%);\n        opacity: 0.6;\n        transition: opacity 0.3s ease;\n      }\n      \n      &:hover {\n        transform: translateY(-6px);\n        box-shadow: var(--shadow-float);\n        background: rgba(255, 255, 255, 0.9);\n        \n        &::before {\n          opacity: 1;\n          height: 6px;\n        }\n      }\n      \n      &.guide-card-1 {\n        --step-color: #4f46e5; // Indigo\n      }\n      \n      &.guide-card-2 {\n        --step-color: #ec4899; // Pink\n      }\n      \n      &.guide-card-3 {\n        --step-color: #8b5cf6; // Violet\n      }\n      \n      &.guide-card-4 {\n        --step-color: #06b6d4; // Cyan\n      }\n      \n      .card-header {\n        text-align: center;\n        padding-top: 8px;\n        \n        .step-number {\n          font-size: 12px;\n          font-weight: 700;\n          letter-spacing: 1px;\n          text-transform: uppercase;\n          opacity: 0.6;\n          margin-bottom: 8px;\n        }\n        \n        .step-icon {\n          margin: 0 auto;\n          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n          transition: transform 0.3s ease;\n        }\n      }\n      \n      &:hover .step-icon {\n        transform: scale(1.1) rotate(5deg);\n      }\n      \n      .card-content {\n        .sample-image-container {\n          text-align: center;\n          \n          .ant-image {\n            border-radius: 12px;\n            overflow: hidden;\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n          }\n        }\n        \n        .ant-list-item {\n          padding: 8px 0;\n          border: none;\n          font-size: 14px;\n          color: #64748b;\n          \n          &:last-child {\n            padding-bottom: 0;\n          }\n        }\n        \n        .ant-alert {\n          border-radius: 10px;\n          border: none;\n          background: rgba(240, 253, 244, 0.8);\n          \n          .ant-alert-message {\n            font-weight: 600;\n            color: #15803d;\n          }\n          \n          .ant-alert-description {\n            color: #166534;\n          }\n        }\n      }\n    }\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .user-guide {\n    .guide-header {\n      h3 {\n        font-size: 24px;\n      }\n    }\n    \n    .guide-cards {\n      .guide-card {\n        margin-bottom: 24px;\n        \n        .card-header {\n          .step-icon {\n            width: 40px;\n            height: 40px;\n            font-size: 20px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
